import * as R from 'ramda';

import { useTeamNavigation } from '@atom/hooks/useTeamNavigation';
import { Button, ListTable } from '@atom/mui';
import colors from '@atom/styles/colors';
import { TimeEntriesDailyTotal } from '@atom/types/timeEntry';
import {
  getSecondaryHeaderCell,
  getTotalsRowStyles,
  timeSheetTableWidths,
  TimesheetViewStyle,
} from '@atom/utilities/timeSheetUtilities';
import { convertMillisToExactHours } from '@atom/utilities/timeUtilities';

const { TableRow, TableCell } = ListTable;

const secondaryHeaderCell = getSecondaryHeaderCell(
  TimesheetViewStyle.CONDENSED,
);
const styles = getTotalsRowStyles(TimesheetViewStyle.CONDENSED);

interface Props {
  dailyTotals: TimeEntriesDailyTotal[];
  dateFilter: number;
  setDateFilter: (date: number) => void;
}

const TimeSheetTableCondensedTotalsRow = ({
  dailyTotals = [],
  dateFilter,
  setDateFilter,
}: Props) => {
  const { teamNavigation } = useTeamNavigation();
  const { payPeriodWeeks } = teamNavigation;

  const fullPayPeriodWeeks = R.flatten(payPeriodWeeks);

  const toggleDateFilter = (date: number) => {
    setDateFilter(dateFilter === date ? null : date);
  };

  return (
    <>
      <TableRow header key="totals" hover={false}>
        <TableCell
          width={timeSheetTableWidths.status}
          style={styles.start}
          center
        />
        <TableCell
          width={timeSheetTableWidths.workType}
          style={secondaryHeaderCell}
        />
        <TableCell style={styles.workInfo} />
        <TableCell
          width={timeSheetTableWidths.task}
          style={secondaryHeaderCell}
        />
        <TableCell
          width={timeSheetTableWidths.userGroup}
          style={secondaryHeaderCell}
        />
        <TableCell
          width={timeSheetTableWidths.budget}
          style={secondaryHeaderCell}
        />
        {fullPayPeriodWeeks.map(day => {
          const duration = R.pathOr(
            undefined,
            ['duration'],
            R.find(R.propEq(day, 'date'))(dailyTotals),
          );

          const text = duration ? convertMillisToExactHours(duration) : '';
          const textColor =
            dateFilter === day
              ? colors.neutral.white
              : convertMillisToExactHours(duration) > 24
                ? colors.brand.red
                : colors.neutral.dim;

          const buttonStyles = {
            ...styles.smallButton,
            color: textColor,
            backgroundColor:
              dateFilter === day ? colors.brand.blue : colors.neutral.white,
          };

          return (
            <TableCell
              width={timeSheetTableWidths.small}
              center
              style={styles.smallCell}
              key={day}
            >
              {!!duration && (
                <Button
                  style={buttonStyles}
                  onClick={() => toggleDateFilter(day)}
                >
                  {text}
                </Button>
              )}
            </TableCell>
          );
        })}
      </TableRow>
    </>
  );
};

export default TimeSheetTableCondensedTotalsRow;
